module.exports = __webpack_public_path__ + "static/elephant-3-f8c79031ca22f64f9d5ead375383e1d3.jpg";